import { render, staticRenderFns } from "./ModulePrivilegeForm.vue?vue&type=template&id=23f2d92a&"
import script from "./ModulePrivilegeForm.vue?vue&type=script&lang=js&"
export * from "./ModulePrivilegeForm.vue?vue&type=script&lang=js&"
import style0 from "./ModulePrivilegeForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports